var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{attrs:{"placeholder":_vm.$t('seeMore'),"invert":"","classes":'gst-btn--see-more',"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }